import { useQuery } from '@tanstack/react-query';
import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';
import { FbmResource } from 'src/models/fbm-resource/_types';
import { fetchFbmResources } from 'src/models/fbm-resource/fbm-resource';

interface FbmResourcesFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
  multiple?: boolean;
}

export const FbmResourcesFilter: React.FC<FbmResourcesFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
  multiple = true,
}) => {
  const { data: resourcesData } = useQuery({
    queryKey: ['fbm-resources-filter'],
    queryFn: () =>
      fetchFbmResources({
        fetchAll: true,
        sort: 'name',
        sortDir: 'asc',
        search: null,
        filters: {},
      }),
  });

  const resources = resourcesData?.fbmResources || [];
  const resourceIds = value ? String(value).split(',') : [];

  let selectedResource = undefined as FbmResource | undefined;
  let selectedResources = [] as FbmResource[];

  if (multiple) {
    selectedResources = resources.filter((r) =>
      resourceIds?.includes(String(r.id))
    );
  } else {
    selectedResource = resources.find((r) => String(r.id) === value);
  }

  if (valueOnly) {
    if (multiple) {
      return <>{selectedResources?.map((r) => r.name)?.join(', ')}</>;
    }
    return <>{selectedResource?.name || ''}</>;
  }

  return (
    <Autocomplete
      multiple={multiple}
      options={resources}
      getOptionLabel={(option: FbmResource) => option.name}
      value={multiple ? selectedResources : selectedResource || null}
      onChange={(_, newValue) => {
        if (multiple) {
          setValue(
            (Array.isArray(newValue) ? newValue : []).map((r) => r.id).join(',')
          );
        } else {
          setValue(String(newValue?.id || ''));
        }
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Select Asset" />
      )}
    />
  );
};

